import { useEffect } from 'react';
/**
 * Hide elements if their widths overflow a container's width
 * @param {{ [key: string]: import('react').RefObject<HTMLElement> }} elementRefs
 * @param {import('react').RefObject<HTMLElement>} containerRef
 * @param {String} defaultDisplay CSS "display" value if element isn't overflown. Defaults to "block"
 */

export default ((elementRefs, containerRef, defaultDisplay = 'block') => {
  useEffect(() => {
    const markOverflowingMenus = () => {
      // Reset elements display
      Object.values(elementRefs).forEach(elementRef => {
        elementRef.current.style.display = defaultDisplay;
      }); // Hide overflown elements

      Object.values(elementRefs).filter(elementRef => elementRef.current.offsetLeft + elementRef.current.offsetWidth > containerRef.current.offsetWidth + containerRef.current.offsetLeft).forEach(overflownElementRef => {
        overflownElementRef.current.style.display = 'none';
      });
    };

    markOverflowingMenus();
    window.addEventListener('resize', markOverflowingMenus);
    return () => {
      window.removeEventListener('resize', markOverflowingMenus);
    };
  }, [containerRef.current]);
});